import React, { useEffect } from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Header/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { useTranslation } from 'react-i18next';
import { CircleSpinner } from 'react-spinners-kit';
import {
  makeSelectIsSubmittingFurniture,
  makeSelectSaveModeFurniture,
} from 'containers/UserActions/selectors';
import {
  resetSaveModeAction,
  saveFurnitureRequestAction,
} from 'containers/UserActions/actions';
import useMedia from 'use-media';
import { FaCartPlus, MdAddShoppingCart } from 'react-icons/all';
import { SaveMode } from '../constants';
import properties from '../../../helpers/config';

// import styled from 'styled-components/macro';

interface StateProps {
  cabinet: Cabinet;
  submitting: boolean;
  saveMode?: SaveMode;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectLastHistoryCabinet(),
  submitting: makeSelectIsSubmittingFurniture(),
  saveMode: makeSelectSaveModeFurniture(),
});

const AddToCurrentOrder = () => {
  const dispatch = useDispatch();
  const { cabinet, submitting, saveMode } = useSelector(stateSelector);
  // const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });

  useEffect(() => {
    if (!submitting && saveMode === SaveMode.AddToCurrentOrder) {
      dispatch(resetSaveModeAction());
    }
  }, [submitting, saveMode]);

  function onClick() {
    /**
     * Get the furniture from store and send it to Kewapp
     */
    dispatch(saveFurnitureRequestAction(SaveMode.AddToCurrentOrder));
  }

  if (isMobile) {
    return null;
  }

  return (
    <button
      className="kewconf-btn-cart bg-gray-800 text-white px-6 py-2 text-l my-2 flex items-center justify-center"
      onClick={onClick}
      disabled={submitting}
    >
      {!submitting && <FiShoppingCart className="h-8 w-8" />}
      <span className="ml-4">
        {!submitting ? (
          t('Add to this order')
        ) : (
          <CircleSpinner size={40} color="#fff" />
        )}
      </span>
    </button>
  );
};

export default AddToCurrentOrder;
